import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import SurveyQuestionsModal from './SurveyQuestionsModal';
import AlertModal from '../../../shared/components/Modal';

const SurveyQuestionsTableActions = ({ data, Callback }) => {

    const [openModal, setOpenModal] = useState(false);
    const [successModal, setSuccessModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [warningModal, setWarningModal] = useState(false);

    useEffect(() => {

    }, []);

    const deleteSurveyQuestion = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}encuesta-item/delete`, {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ id_encuesta_item: data.data.original.id_encuesta_item })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setSuccessModal(true);
                Callback();
            }
            else {
                throw new Error('Ha ocurrido un error en el Servidor');
            }
        }).catch(err => {
            setErrorModal(true);
            console.log(err);
        });
    }

    return (
        <Fragment>
            <td role="cell">
                <Tooltip title="Actualizar Pregunta">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => setOpenModal(true)}>
                        <FontAwesomeIcon icon={faEdit} />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Eliminar Pregunta">
                    <IconButton style={{ fontSize: '15px' }} onClick={() => setWarningModal(true)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </IconButton>
                </Tooltip>
            </td>
            <SurveyQuestionsModal opened={openModal} closeModal={() => setOpenModal(false)} questionData={data.data.original} Callback={() => Callback()} />

            <AlertModal
                color={"success"}
                title={"Item eliminado exitosamente"}
                modal={successModal}
                onOk={() => {
                    setSuccessModal(false);
                }}
                toggle={() => {
                    setSuccessModal(false);
                }}
            />

            <AlertModal
                color={"danger"}
                title={"Ha ocurrido un error eliminando el item"}
                modal={errorModal}
                onOk={() => {
                    setErrorModal(false);
                }}
                toggle={() => {
                    setErrorModal(false);
                }}
            />

            <AlertModal
                color={"warning"}
                title={"Esta seguro que desea eliminar este item"}
                modal={warningModal}
                onOk={() => {
                    deleteSurveyQuestion();
                }}
                toggle={() => {
                    setWarningModal(false);
                }}
            />

        </Fragment>)
}

export default SurveyQuestionsTableActions;